var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-img',_vm._b({attrs:{"fluid":"","src":_vm.logoImgUrl,"alt":"Center image"}},'b-img',_vm.logoProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }